import { Component } from "preact";
import { connect } from "react-redux";
import { change, Field, formValueSelector, reduxForm } from "redux-form";
import ActionBar from "../../components/ActionBar";
import ActionButton from "../../components/ActionButton";
import BookingHeader from "../../components/BookingHeader";
import Content from "../../components/Content";
import CountDown from "../../components/CountDown";
import DiscountCode from "../../components/DiscountCode";
import CheckboxField from "../../components/fields/CheckboxField";
import InputField from "../../components/fields/InputField";
import RadioField from "../../components/fields/RadioField";
import TextAreaField from "../../components/fields/TextareaField";
import Page from "../../components/Page";
import TwoCols from "../../components/TwoCols";
import WarningMessage from "../../components/WarningMessage";
import YourOrder from "../../components/YourOrder";
import config from "../../config";
import { getEvent } from "../../state/actions/eventActions";
import { getGiftCardPage } from "../../state/actions/giftCardActions";
import { getOrder, saveOrderData } from "../../state/actions/orderActions";
import { setSeatingMapRequired } from "../../state/actions/seatingMapActions";
import { pageChange } from "../../utils/BrowserUtils";
import { scrollToErrors } from "../../utils/ScrollToErrors";
import { email, required } from "../../utils/Validators";
import GiftCardPageHeader from "../giftCards/GiftCardPageHeader";
import OrderQuestions from "./OrderQuestions";
import TicketsQuestions from "./TicketsQuestions";
import { getTicketValues } from "../../utils/stateConstructors";
import RequiredFields from "../../components/RequiredFields";
import OrderTotal from "../../components/OrderTotal";
import { css } from "emotion";

const formName = "details";

const nextStageButton = css({ height: "40px !important", minWidth: 150 });

class DetailsWrapper extends Component {
  eventDetailsDidMount = () => {
    const { event, eventSlug, order, orderId, getEvent } = this.props;
    if (!event.data && !event.loading) {
      getEvent(eventSlug, undefined, false, orderId, true);
    }
    if (event.data && order.data) {
      this.determineSeatingMap(event.data, order.data);
    }
    pageChange("Enter Details", event);
  };

  globalDetailsDidMount = () => {
    const {
      order,
      orderId,
      getOrder,
      giftCards,
      eventSlug,
      getGiftCardPage
    } = this.props;
    if (!order.data && !order.loading) {
      getOrder(orderId);
    }
    if (!giftCards.giftCardPage && !giftCards.loading) {
      getGiftCardPage(eventSlug);
    }
  };

  globalDetailsDidUpdate = () => {};

  eventDetailsDidUpdate = () => {
    const { event, order, seatingMap } = this.props;
    if (event.data && order.data && !seatingMap.seatingMapEvaluated) {
      this.determineSeatingMap(event.data, order.data);
    }
  };

  determineSeatingMap = (eventData, orderData) => {
    const { setSeatingMapRequired } = this.props;
    let seatingMapId;
    if (orderData) {
      const { tickets } = orderData;
      const event = eventData;
      if (event.seatingMaps && tickets) {
        event.seatingMaps.forEach(seatingMap => {
          const isPublic = seatingMap.public !== false;
          seatingMap.ticketTypeSet.forEach(ticketType => {
            const containsPackageTicket =
              tickets.filter(
                ticket => String(ticket.packageId) === String(ticketType)
              ).length > 0;
            const containsTicketType =
              tickets.filter(
                ticket => String(ticket.ticketTypeId) === String(ticketType)
              ).length > 0;
            if (
              (containsPackageTicket || containsTicketType) &&
              !seatingMapId &&
              isPublic
            ) {
              seatingMapId = seatingMap.id;
            }
          });
        });
      }
    }
    setSeatingMapRequired(seatingMapId);
  };

  saveEventDetails = values => {
    const { eventSlug, event, order, saveOrderData, seatingMap } = this.props;
    if (order.detailsRequest.loading) {
      return;
    }
    const orderData = {
      ...values.order,
      _id: order.data._id
    };
    // add the affiliate code to the order if there is one
    try {
      const affiliateCode = localStorage.getItem(`${eventSlug}-affiliate`);
      if (affiliateCode) {
        orderData.affiliateCode = affiliateCode;
      }
    } catch (err) {}
    saveOrderData(
      eventSlug,
      event.id,
      orderData,
      order.data.tickets,
      values.tickets,
      seatingMap.seatingMapRequired || event.data.settings.enableTicketAssigning
    );
  };

  saveGlobalDetails = values => {
    const { order, saveOrderData, seatingMap, giftCards } = this.props;
    if (order.detailsRequest.loading) {
      return;
    }
    const { slug } = giftCards.giftCardPage;
    const orderData = {
      ...values.order,
      _id: order.data._id
    };

    saveOrderData(
      slug,
      order.userId,
      orderData,
      order.data.giftCards,
      values.giftCards,
      false,
      true
    );
  };

  determineIsGlobal = () => {
    return this.props.path
      ? this.props.path.indexOf("/gift-cards/") > -1
      : false;
  };

  getForm = () => {
    const {
      ticketsAdditionalQuestions,
      orderAdditionalQuestions,
      businessPurpose,
      businessTaxId,
      businessName,
      buyerData,
      sameAsBuyerChecks,
      seatingMap,
      additionalQuestionsPreview,
      ticketAssigningEnabled,
      orderSummary
    } = this.props;
    const isGlobal = this.determineIsGlobal();
    let detailsProps = {
      saveDetails: this.saveEventDetails,
      ticketsAdditionalQuestions,
      orderAdditionalQuestions,
      businessPurpose,
      businessTaxId,
      seatingMapAvailable: seatingMap.seatingMapRequired,
      businessName,
      buyerData,
      sameAsBuyerChecks,
      additionalQuestionsPreview,
      isGlobal,
      ticketAssigningEnabled,
      orderSummary
    };
    if (isGlobal) {
      detailsProps.saveDetails = this.saveGlobalDetails;
      detailsProps.ticketsAdditionalQuestions = [];
      detailsProps.orderAdditionalQuestions = [];
    }
    return <DetailsForm {...detailsProps} />;
  };

  render() {
    const isGlobal = this.determineIsGlobal();
    let childProps = {};
    if (isGlobal) {
      childProps = {
        getForm: this.getForm,
        didMount: this.globalDetailsDidMount,
        didUpdate: this.globalDetailsDidUpdate,
        isGlobal: isGlobal
      };
    } else {
      childProps = {
        save: this.saveEventDetails,
        didMount: this.eventDetailsDidMount,
        didUpdate: this.eventDetailsDidUpdate,
        getForm: this.getForm,
        isGlobal: isGlobal
      };
    }
    return <Details {...this.props} {...childProps} />;
  }
}

class Details extends Component {
  componentDidMount() {
    const { didMount } = this.props;
    didMount();
  }

  componentDidUpdate() {
    const { didUpdate } = this.props;
    didUpdate();
  }

  render({
    event,
    order,
    merchandise,
    seatingMap,
    additionalQuestionsPreview,
    isGlobal,
    getForm,
    giftCards
  }) {
    if (additionalQuestionsPreview) {
      return <Page>{getForm()}</Page>;
    }
    if (order && order.orderGet.error) {
      return (
        <Page>
          <WarningMessage title="Order could not be loaded" />
        </Page>
      );
    }
    if (
      event.loading ||
      (!event.data && !isGlobal) ||
      (giftCards.loading && isGlobal) ||
      (!giftCards.giftCardPage && isGlobal) ||
      !order.data ||
      merchandise.merch.loading
    ) {
      return;
    }
    if (order && order.data.status === "complete") {
      return (
        <Page>
          <WarningMessage title="Order has been completed" />
        </Page>
      );
    }

    if (order.detailsRequest.error) {
      window.scrollTo(0, 0);
    }

    return (
      <div>
        {isGlobal ? <GiftCardPageHeader /> : null}
        <Page isGlobal={isGlobal}>
          <Content>
            <BookingHeader
              event={event}
              orderId={order.data._id}
              includeSeatingMap={seatingMap.seatingMapRequired}
              isGlobal={isGlobal}
            />
            <TwoCols>
              {getForm()}
              <YourOrder allowDiscountsAdd={true} isGlobal={isGlobal} />
            </TwoCols>
          </Content>
        </Page>
      </div>
    );
  }
}

let DetailsForm = ({
  event,
  order,
  handleSubmit,
  saveDetails,
  seatingMapAvailable,
  ticketsAdditionalQuestions,
  orderAdditionalQuestions,
  businessPurpose,
  businessTaxId,
  businessName,
  ticketAssigningEnabled,
  buyerData,
  dispatch,
  sameAsBuyerChecks,
  additionalQuestionsPreview,
  isGlobal,
  orderSummary
}) => {
  const openLink = (link, target) => {
    window.open(link, target);
  };
  const changeFieldValue = (field, value) => {
    dispatch(change(formName, field, value));
  };

  let mobileRequired =
    !isGlobal &&
    event.data.settings &&
    event.data.settings.mobileRequired === false
      ? false
      : true;
  // quick hard code for Atlassian / Remove after models change
  if (!isGlobal && event.data.userId === "swxRT5dkHLblWjQFhVepr2zJpWG3") {
    mobileRequired = false;
  }

  const isConference = !isGlobal && event.data.settings.enableTicketAssigning;
  const businessPurposeOptions = [
    {
      label: "Yes",
      value: "true"
    },
    {
      label: "No",
      value: "false"
    }
  ];
  const businessTaxIdName = config("TAX_NAME") || "Tax ID";
  let detailsAdditionQuestions =
    !isGlobal &&
    event.data.additionalQuestions &&
    event.data.additionalQuestions.length
      ? event.data.additionalQuestions.filter(q => !q.askAfterCheckout)
      : [];
  detailsAdditionQuestions = detailsAdditionQuestions.map(q => {
    if (q.type === "multiSelect" && q.options && q.options.length) {
      q.options = q.options.map(o => {
        const newOption = o.label
          ? {
              ...o
            }
          : {
              ...o,
              id: o._id,
              label: o.value,
              value: false
            };
        return newOption;
      });
    }
    return q;
  });
  let btnText = ticketAssigningEnabled ? "Assign tickets" : "Checkout";
  btnText = seatingMapAvailable ? "Select Seats" : btnText;
  const hideIsBusinessQuestion =
    event.data &&
    event.data.settings &&
    event.data.settings.hideIsBusinessQuestion;

  const ticketQuestions =
    !isConference && !isGlobal ? (
      <TicketsQuestions
        tickets={order.data.tickets}
        ticketTypes={event.data.ticketTypes}
        ticketsAdditionalQuestions={ticketsAdditionalQuestions}
        additionalQuestions={detailsAdditionQuestions}
        buyerData={buyerData}
        changeFieldValue={changeFieldValue}
        sameAsBuyerChecks={sameAsBuyerChecks}
      />
    ) : null;
  return (
    <div>
      <CountDown margin="0px 0px 12px 0px" isGlobal={isGlobal} />
      <RequiredFields />
      <form onSubmit={handleSubmit(saveDetails)}>
        <div
          style={
            order.timeExpired
              ? {
                  pointerEvents: "none"
                }
              : {}
          }
        >
          <div
            style={{
              marginBottom: 24
            }}
          >
            {order.detailsRequest.error ? (
              <div>
                {order.detailsRequest.additionalQuestionQuantityError ? (
                  <div>
                    <p class="text-error">
                      Some selections are no longer available
                    </p>
                    {order.detailsRequest.error.message.map(msg => {
                      return <p class="text-error">{msg}</p>;
                    })}
                  </div>
                ) : (
                  <p class="text-error">{order.detailsRequest.error.message}</p>
                )}
              </div>
            ) : (
              ""
            )}
            <DiscountCode allowAdd={true} />
            <fieldset>
              <legend>
                <h3 class="sub-header">Buyer Information</h3>
              </legend>
              <Field
                label="First Name"
                type="text"
                name="order.firstName"
                component={InputField}
                required={true}
                validate={required}
                autocomplete="given-name"
              />
              <Field
                label="Last Name"
                type="text"
                name="order.lastName"
                component={InputField}
                required={true}
                validate={required}
                autocomplete="family-name"
              />

              <Field
                label="Email"
                type="text"
                name="order.email"
                component={InputField}
                required={true}
                validate={[required, email]}
                autocomplete="email"
              />
              <Field
                label="Mobile"
                type="text"
                name="order.mobile"
                component={InputField}
                required={mobileRequired}
                validate={mobileRequired ? required : null}
                autocomplete="tel"
              />

              <hr style={{ margin: "24px 0px" }} />

              {!isGlobal && !hideIsBusinessQuestion ? (
                <Field
                  label="Is your purchase for business purposes?"
                  name="order.businessPurpose"
                  component={RadioField}
                  defaultValue={"false"}
                  inline={true}
                  options={businessPurposeOptions}
                  validate={required}
                />
              ) : null}

              {businessPurpose === "true" && (
                <div
                  style={{
                    background: "#FAFAF9",
                    padding: 12
                  }}
                >
                  <Field
                    label={businessTaxIdName}
                    type="text"
                    name="order.businessTaxId"
                    component={InputField}
                    validate={required}
                  />
                  <Field
                    label="Business Name"
                    type="text"
                    name="order.businessName"
                    component={InputField}
                    validate={required}
                  />
                </div>
              )}
              <hr style={{ margin: "0px 0px 24px 0px" }} />

              <OrderQuestions
                additionalQuestions={detailsAdditionQuestions}
                orderAdditionalQuestions={orderAdditionalQuestions}
                changeFieldValue={changeFieldValue}
                tickets={order.data.tickets}
              />
            </fieldset>
          </div>
          {!isGlobal ? ticketQuestions : <GiftCardDetails order={order} />}{" "}
          {!isGlobal && event.data.settings.mailList ? (
            <div>
              <Field
                label="Keep me posted on new events and updates about the Humanitix journey"
                name="order.allowMarking"
                component={CheckboxField}
              />
            </div>
          ) : null}
        </div>
        <div>
          By clicking {btnText.toLowerCase()}, I agree to the{" "}
          <a
            href="#"
            onClick={() =>
              openLink(
                `/pdfs/humanitix_purchaser_terms_and_conditions.pdf`,
                "_blank"
              )
            }
            style={{ textDecoration: "underline" }}
          >
            Humanitix ticketing terms
          </a>{" "}
          and have read the{" "}
          <a
            href="#"
            onClick={() =>
              openLink(`/pdfs/humanitix_privacy_policy.pdf`, "_blank")
            }
            style={{ textDecoration: "underline" }}
          >
            Humanitix privacy policy
          </a>
          . I agree that Humanitix may pass on my information to the event
          organiser.
        </div>
        {!additionalQuestionsPreview ? (
          <ActionBar>
            <OrderTotal orderSummary={orderSummary} />
            <ActionButton
              disabled={
                order.detailsRequest.loading ||
                order.timeExpired ||
                order.addDiscountRequest.loading
              }
              loading={
                order.detailsRequest.loading || order.addDiscountRequest.loading
              }
              dataCY={ticketAssigningEnabled ? "assign" : "checkout"}
              classNames={nextStageButton}
            >
              {btnText}
            </ActionButton>
          </ActionBar>
        ) : null}
      </form>
    </div>
  );
};

let GiftCardDetails = ({ order }) => {
  const { giftCards } = order.data;
  return (
    <div>
      <h3 class="sub-header">Gift Card Information</h3>
      <p style={{ borderBottom: "1px solid #eeeeee", paddingBottom: 8 }}>
        Send this gift card to a friend.
      </p>
      {giftCards.map((giftcard, i) => {
        return (
          <div>
            <h4 style={{ borderBottom: "1px solid #eeeeee", paddingBottom: 8 }}>
              {`${i + 1}. ${giftcard.giftCardTypeName} $${giftcard.price}`}
            </h4>
            <Field
              label="Sender name (From)"
              type="text"
              name={`giftCards[${i}].senderName`}
              component={InputField}
              required={true}
              validate={[required]}
            />
            <Field
              label="Recipient name (To)"
              type="text"
              name={`giftCards[${i}].recipientName`}
              component={InputField}
              required={true}
              validate={[required]}
            />
            <Field
              label="Recipient email"
              type="text"
              name={`giftCards[${i}].recipientEmail`}
              component={InputField}
              required={true}
              validate={[required, email]}
              autocomplete="email"
            />
            <Field
              label="Message for recipient"
              type="text"
              name={`giftCards[${i}].message`}
              component={TextAreaField}
            />
          </div>
        );
      })}
    </div>
  );
};

DetailsForm = reduxForm({
  form: formName,
  destroyOnUnmount: false,
  onSubmitFail: errors => {
    scrollToErrors();
  }
})(DetailsForm);

function getOrderValues(
  order,
  providedOrderData,
  additionalQuestions,
  formOrder
) {
  if (formOrder) {
    return formOrder;
  }
  const allowedOrderData = ["firstName", "lastName", "mobile", "email"];
  allowedOrderData.forEach(key => {
    order[key] =
      providedOrderData && providedOrderData[key]
        ? providedOrderData[key]
        : null;
  });

  if (order.businessPurpose === false || !order.businessPurpose) {
    order.businessPurpose = "false";
  }
  if (order && order.additionalFields) {
    const mappedOrder = {
      ...order
    };
    mappedOrder.additionalFields = {};
    if (order.additionalFields && order.additionalFields.length > 0) {
      order.additionalFields.forEach(field => {
        mappedOrder.additionalFields[field.questionId] = field.value;
      });
    } else if (additionalQuestions && additionalQuestions.length > 0) {
      additionalQuestions.forEach(question => {
        question.defaultValue && question.perOrder && !question.askAfterCheckout
          ? (mappedOrder.additionalFields[question._id] = question.defaultValue)
          : "";
      });
    }

    return mappedOrder;
  }

  return order;
}

const selector = formValueSelector(formName);

DetailsForm = connect(
  (state, ownProps) => {
    const { isGlobal } = ownProps;
    const order = getOrderValues(
      state.order.data,
      state.order.providedOrderData,
      isGlobal ? [] : state.event.data.additionalQuestions,
      selector(state, "order")
    );
    const initialValues = {
      order
    };
    if (!isGlobal) {
      const tickets = getTicketValues(
        state.order.data,
        state.event.data.additionalQuestions,
        selector(state, "tickets")
      );
      initialValues.tickets = tickets;
    } else {
      const giftCards = state.order.data.giftCards.map(giftCard => {
        return {
          giftCardId: giftCard._id
        };
      });
      initialValues.giftCards = giftCards;
    }

    return {
      initialValues: initialValues,
      event: state.event,
      order: state.order
    };
  },
  {}
)(DetailsForm);

export default connect(
  (state, ownProps) => {
    return {
      event: state.event,
      order: state.order,
      orderSummary: state.orderSummary,
      seatingMap: state.seatingMap,
      merchandise: state.merchandise,
      giftCards: state.giftCards,
      ticketSelection: state.ticketSelection,
      ticketAssigningEnabled: state.event.data
        ? state.event.data.settings.enableTicketAssigning
        : false,
      buyerData: {
        firstName: selector(state, "order.firstName"),
        lastName: selector(state, "order.lastName"),
        mobile: selector(state, "order.mobile"),
        email: selector(state, "order.email")
      },
      businessPurpose: selector(state, "order.businessPurpose"),
      businessTaxId: selector(state, "order.businessTaxId"),
      businessName: selector(state, "order.businessName"),
      orderAdditionalQuestions: selector(state, "order.additionalFields"),
      ticketsAdditionalQuestions: selector(state, "tickets"),
      sameAsBuyerChecks: selector(state, "sameAsBuyerChecks")
    };
  },
  {
    saveOrderData,
    getEvent,
    getOrder,
    setSeatingMapRequired,
    getGiftCardPage
  }
)(DetailsWrapper);



// WEBPACK FOOTER //
// ./routes/details/Details.js